import './ServiceCard.css'

export const ServiceCard = (props) => {

  const { onClick, icon, header, info } = props;
  return (
    <>
      <div className="servcard module" onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
        <div className="img">
          <i className={icon}></i>
        </div>
        <div className="serv-name">{header}</div>
        <div className="txt">
          <p>
            {info}
          </p>
        </div>
      </div>
    </>
  );
};
